<main class="wrap">
  <h1>Watch Party</h1>
  <form id="loginForm" class="panel">
    <p class="hint">Utilise ton compte Emby habituel.</p>
    <label>Nom d'utilisateur
      <input id="username" autocomplete="username" required autofocus />
    </label>
    <label>Mot de passe
      <input id="password" type="password" autocomplete="current-password" required />
    </label>
    <button type="submit">Se connecter</button>
    <p id="error" class="error"></p>
  </form>
</main>
